import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { Check, Remove, Restore, Search } from '@material-ui/icons';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import PostAddIcon from '@material-ui/icons/PostAdd';
import Settings from '@material-ui/icons/Settings';
import Save from '@material-ui/icons/Save';
import HighlightOff from '@material-ui/icons/HighlightOff';
import LoadingModal from '../components/LoadingModal';
import BasicTable from '../../../components/BasicTable.js';
import SpinnerComponent from '../../../components/SpinnerComponent';
import TwoActionsAlertDialog from '../../../components/TwoActionsAlertDialog';
import SelezioneGruppo from '../components/SelezioneGruppo';
import TablePageToolbar from '../components/TablePageToolbar';
import ActionButton from '../../../components/ActionButton';
import ModalSelezioneGruppo from '../components/ModalSelezioneGruppo';
import ModalSelezioneConsulente from '../components/ModalSelezioneConsulente';
import ModalSelezioneEsercizioCommerciale from '../components/ModalSelezioneEsercizioCommerciale';
import GoToPageModal from '../components/GoToPageModal';
import ModificaModelloManualeButton from '../components/ModificaModelloManualeButton';
import ModalSelezioneModalitaModello from '../dettaglio_modello/ModalSelezioneModalitaModello.js';

import { getBrands } from '../../../utils/api/brand_api';
import { getGruppi } from '../../../utils/api/gruppi_api';
import {
  cancellaModello,
  creaManualePersonalizzato,
  creaModelloPersonalizzato,
  getFlagControlliSemplificatiManualeFromId,
  getModelli,
  getModelliCount,
  getModelliCountFiltered,
  getModelliFiltered,
  updateModello,
} from '../../../utils/api/modelli_and_manuali_api';
import { getCapitoliCount } from '../../../utils/api/capitoli_api';

import moment from 'moment';
import { reportApiError } from '../../../utils/reportApiError';
import 'moment/locale/it';

const styles = {
  mainContainer: {
    textAlign: 'center',
    color: 'black',
  },
};

const dateFormat = 'DD-MM-YYYY HH:mm';

export const Component = withRouter(({ history, location }) => {});

class ModelliPersonalizzatiTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modelli: [],
      brands: [],
      gruppoId: null,
      gruppi: [],
      esercizioId: null,
      selectedGruppoId: null,
      consulenteId: null,
      loading: true,
      modelloBaseId: null,
      modelloCreatoId: null,
      edit: false,
      showHiddenModels: false,
      twoActionsAlertVisible: false,
      modalTitle: '',
      modalMessage: '',
      modelloSelezionato: null,
      newModelloId: null,
      showModalSelezioneGruppo: false,
      showModalSelezioneConsulente: false,
      showModalSelezioneEsercizio: false,
      showModalSelezioneModalita: false,
      isChapterSelectionBlocked: false,
      isControlliSelectionBlocked: false,
      loadingModal: false,
      showGoToPageModal: false,
      goToPageMessage: '',
      goToPagePath: '',
      isModello: false,
      origin: 'Manuale',
      totalPages: 10,
      loadedPage: 0,
      pageSize: 10,
      filters: {
        idModello: '',
        idGruppo: '',
        titolo: '',
        regolamenti: '',
      },
      filtroGestioneSeparata: null, // se 'null' vedo tutti gli esercizi
    };
  }

  componentDidMount() {
    let gruppoId = this.props.gruppoId; // Can be null if user has role "ADMIN"
    this.setState({
      gruppoId,
      selectedGruppoId: gruppoId,
    });
    if (this.props.consulenteId === null) {
      // User is admin
      this.fetchGruppi();
    } else {
      this.fetchBrands(gruppoId);
    }
  }

  onPageChange = (pageIndex) => {
    this.setState(
      {
        loadedPage: pageIndex,
        edit: false,
      },
      () =>
        this.fetchModelliOnPageChange(
          this.state.filters.idGruppo,
          this.state.showHiddenModels,
          pageIndex,
        ),
    );
  };

  generateFilterColumn = ({ id, placeholder, filterValue, onChange }) => {
    return {
      Header: placeholder,
      id: id,
      accessor: (d) => d[id],
      filterable: true,
      minWidth: 120,
      Filter: (
        <TextField
          variant="outlined"
          fullWidth
          value={filterValue}
          onChange={(e) => {
            const value = e.target.value;
            onChange(value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  disabled={this.state.edit}
                  size="small"
                  onClick={() => {
                    this.setState(
                      {
                        loadedPage: 0,
                      },
                      () => {
                        this.fetchModelliForResearch(
                          this.state.filters.idGruppo,
                          this.state.showHiddenModels,
                        );
                      },
                    );
                  }}
                >
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ),
    };
  };

  generateFilterColumnWithEditableFields = ({
    id,
    placeholder,
    filterValue,
    onChange,
  }) => {
    return {
      Header: placeholder,
      id: id,
      accessor: (d) => d[id],
      filterable: true,
      minWidth: 340,
      Cell: this.renderEditable,
      Filter: (
        <TextField
          variant="outlined"
          fullWidth
          value={filterValue}
          onChange={(e) => {
            const value = e.target.value;
            onChange(value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  disabled={this.state.edit}
                  size="small"
                  onClick={() => {
                    this.setState(
                      {
                        loadedPage: 0,
                      },
                      () => {
                        this.fetchModelliForResearch(
                          this.state.filters.idGruppo,
                          this.state.showHiddenModels,
                        );
                      },
                    );
                  }}
                >
                  <Search />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      ),
    };
  };

  fetchGruppi = () => {
    getGruppi(null, null, 0, 3000, 'nome')
      .then((result) => {
        let newarray = [{ id: -1, nome: 'Tutti i gruppi' }];
        newarray.push(...result);
        let gruppoId = this.state.gruppoId;
        if (gruppoId === null) {
          gruppoId = -1;
        }
        this.setState({
          gruppi: newarray,
          gruppoId,
        });
        this.fetchBrands();
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  fetchBrands = () => {
    getBrands(0, 1000, 'id')
      .then((result) => {
        this.setState({
          brands: result,
        });
        this.fetchModelli(this.props.gruppoId, this.state.showHiddenModels);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  fetchModelli = (gruppoId, hidden) => {
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;
    if (this.props.consulenteId !== null) {
      gruppoId = this.props.gruppoId;
    }
    getModelliCount(hidden, gruppoId, isConsulente, null)
      .then((countResult) => {
        return getModelli(
          hidden,
          gruppoId,
          isConsulente,
          null,
          0,
          10,
          'id',
        ).then((result) => {
          this.setState({
            loading: false,
            modelli: result,
            totalPages: Math.ceil(countResult / 10),
            loadedPage: 0,
            filters: {
              idModello: '',
              idGruppo: gruppoId === null ? -1 : gruppoId,
              titolo: '',
              regolamenti: '',
            },
          });
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  fetchModelliOnPageChange = (gruppoId, hidden, currentPage) => {
    const { filters } = this.state;
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;
    if (this.props.consulenteId !== null) {
      gruppoId = this.props.gruppoId;
    } else {
      gruppoId = this.state.filters.idGruppo;
    }
    getModelliFiltered(
      hidden,
      gruppoId,
      isConsulente,
      null,
      currentPage,
      10,
      'id',
      filters.idModello,
      filters.titolo,
      filters.regolamenti,
    )
      .then((result) => {
        this.setState({
          loading: false,
          modelli: result,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  fetchModelliForResearch = (gruppoId, hidden) => {
    const { filters } = this.state;
    const isConsulente =
      this.props.consulenteId !== null && !this.props.superconsulenteView;
    if (this.props.consulenteId !== null) {
      gruppoId = this.props.gruppoId;
    } else {
      gruppoId = this.state.filters.idGruppo;
    }
    getModelliCountFiltered(
      hidden,
      gruppoId,
      isConsulente,
      null,
      filters.idModello,
      filters.titolo,
      filters.regolamenti,
    )
      .then((countResult) => {
        getModelliFiltered(
          hidden,
          gruppoId,
          isConsulente,
          null,
          this.state.loadedPage,
          10,
          'id',
          filters.idModello,
          filters.titolo,
          filters.regolamenti,
        )
          .then((result) => {
            this.setState({
              loading: false,
              modelli: result,
              totalPages:
                Math.ceil(countResult / 10) > 0
                  ? Math.ceil(countResult / 10)
                  : 1,
              loadedPage: 0,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
            reportApiError(error);
          });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  updateModello = () => {
    updateModello(this.state.modelloSelezionato)
      .then((result) => {
        // TEMPORARY DISABLED FETCH REQUEST AFTER UPDATE:
        //this.fetchModelli(this.state.gruppoId);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  executeCreationModelloPersonalizzato = (
    manualeBaseId,
    gruppoId,
    hasChapters,
    isModello,
    isControlloSemplificato,
    tipologiaRevisione,
  ) => {
    if (!isModello) {
      this.setState(
        {
          showModalSelezioneModalita: false,
          loadingModal: true,
        },
        () => {
          creaManualePersonalizzato(
            this.state.esercizioId,
            manualeBaseId,
            this.state.consulenteId,
            hasChapters,
            isControlloSemplificato,
            tipologiaRevisione,
          )
            .then((result) => {
              this.setState(
                {
                  loadingModal: false,
                },
                () => {
                  this.openGoToModal(false, result.manuale.id, hasChapters);
                },
              );
            })
            .catch((error) => {
              this.setState({
                loading: false,
                loadingModal: false,
              });
              reportApiError(error);
            });
        },
      );
    } else {
      this.setState(
        {
          showModalSelezioneModalita: false,
          loadingModal: true,
        },
        () => {
          creaModelloPersonalizzato(
            manualeBaseId,
            gruppoId,
            hasChapters,
            isControlloSemplificato,
            tipologiaRevisione,
          )
            .then((result) => {
              this.setState(
                {
                  loadingModal: false,
                },
                () => {
                  this.openGoToModal(true, result.id, hasChapters);
                },
              );
            })
            .catch((error) => {
              this.setState({
                loading: false,
                loadingModal: false,
              });
              reportApiError(error);
            });
        },
      );
    }
  };

  openGoToModal = (isModello, modelloId, hasChapters) => {
    let message =
      'Clicca su Avanti per accedere alla pagina di costruzione del contenuto del modello.';
    let path =
      '/amministrazione/manuali/nuovomanuale/' +
      modelloId +
      '/modello/' +
      hasChapters;
    if (!isModello) {
      message =
        'Clicca su Avanti per accedere alla pagina di costruzione del contenuto del manuale.';
      path =
        '/amministrazione/manuali/nuovomanuale/' +
        modelloId +
        '/manuale/' +
        hasChapters;
    }
    this.setState({
      showGoToPageModal: true,
      showModalSelezioneModalita: false,
      goToPageMessage: message,
      goToPagePath: path,
    });
  };

  onGoToPageCanceled = () => {
    let isAdmin =
      !this.props.superconsulenteView && this.props.consulenteId === null;
    if (isAdmin) {
      this.setState(
        {
          showGoToPageModal: false,
          loading: true,
          gruppoId: -1,
        },
        () => {
          this.fetchModelli(this.state.gruppoId, this.state.showHiddenModels);
        },
      );
    } else {
      this.setState(
        {
          showGoToPageModal: false,
          loading: true,
        },
        () => {
          this.fetchModelli(this.state.gruppoId, this.state.showHiddenModels);
        },
      );
    }
  };

  handleSelectedGruppo = (gruppoId) => {
    let prevFilters = this.state.filters;
    prevFilters.idGruppo = gruppoId;
    this.setState({
      //gruppoId,
      edit: false,
      loadedPage: 0,
      filters: prevFilters,
      loading: true,
    });
    this.fetchModelliForResearch(gruppoId, this.state.showHiddenModels);
  };

  onHiddenManualiSelection = (e) => {
    let hidden = e.target.value;
    this.setState({
      showHiddenModels: hidden,
      loading: true,
      loadedPage: 0,
      edit: false,
    });
    this.fetchModelliForResearch(this.state.filters.idGruppo, hidden);
  };

  onCreaModelloButtonClicked = () => {
    const isAdmin = this.props.consulenteId === null;
    if (isAdmin) {
      this.setState({
        showModalSelezioneGruppo: true,
        modelloBaseId: null,
        origin: 'Modello',
        isModello: true,
      });
    } else {
      this.setState(
        {
          isModello: true,
          origin: 'Modello',
          modelloBaseId: null,
        },
        () => {
          this.onOpenModalModalita();
        },
      );
    }
  };

  onCancelGruppoSelection = () => {
    let currentGruppoId = this.state.gruppoId;
    this.setState({
      showModalSelezioneGruppo: false,
      loading: false,
      selectedGruppoId: currentGruppoId,
    });
  };

  saveSelectedGruppoForModello = (gruppoId) => {
    this.setState({
      selectedGruppoId: gruppoId,
      gruppoId: gruppoId,
    });
  };

  onCreaButtonInModalClicked = (origin) => {
    if (origin === 'Modello') {
      let gruppoId = this.state.selectedGruppoId;
      this.setState(
        {
          showModalSelezioneGruppo: false,
          selectedGruppoId: gruppoId,
          loading: true,
        },
        this.onOpenModalModalita,
      );
    } else {
      let gruppoId = this.state.selectedGruppoId;
      this.setState({
        showModalSelezioneGruppo: false,
        selectedGruppoId: gruppoId,
        loading: true,
        showModalSelezioneConsulente: true,
      });
    }
  };

  onPublicationButtonClicked = () => {
    const isEmptyField =
      this.state.modelloSelezionato.titolo.trim().length === 0 ||
      this.state.modelloSelezionato.regolamenti.trim().length === 0;

    this.setState((prevState) => ({
      modelloSelezionato: {
        ...prevState.modelloSelezionato,
        stato: 'PUBBLICATO',
      },
      modalTitle: isEmptyField
        ? 'Verifica dei dati inseriti'
        : 'Pubblicazione bozza',
      modalMessage: isEmptyField
        ? "I campi 'Titolo' e/o 'Regolamenti' sono vuoti. Clicca su OK per proseguire con la pubblicazione oppure su INDIETRO per annullare la richiesta."
        : 'Cliccare su OK per confermare la richiesta di pubblicazione oppure su INDIETRO per annullare la richiesta.',
      twoActionsAlertVisible: true,
      edit: false,
    }));
  };

  onPublicationCancelled = () => {
    this.setState((prevState) => ({
      modelloSelezionato: {
        ...prevState.modelloSelezionato,
        stato: 'BOZZA',
      },
      twoActionsAlertVisible: false,
    }));
  };

  onAlertOkButtonPressed = () => {
    this.setState((prevState) => {
      const updatedModelii = prevState.modelli.map((modello) =>
        modello.id === prevState.modelloSelezionato.id
          ? { ...modello, stato: 'PUBBLICATO' }
          : modello,
      );

      return {
        modelli: updatedModelii,
        twoActionsAlertVisible: false,
      };
    }, this.updateModello);
  };

  onModificaClicked = (record, event) => {
    if (!this.state.edit) {
      this.setState({
        edit: true,
        modelloSelezionato: record,
      });
    } else {
      this.setState({
        edit: false,
      });
      this.updateModello();
    }
  };

  onClonaClicked = (record, event) => {
    let selectgruppo = this.props.consulenteId === null ? true : false; // If admin, open modal to select gruppo

    if (selectgruppo) {
      this.setState({
        modelloBaseId: record.id,
        showModalSelezioneGruppo: true,
        origin: 'Modello',
        isModello: true,
        modelloSelezionato: record,
      });
    } else {
      this.setState(
        {
          loading: true,
          modelloBaseId: record.id,
          selectedGruppoId: record.gruppoId,
          modelloSelezionato: record,
        },
        () => {
          getCapitoliCount(this.state.modelloBaseId)
            .then((result) => {
              return getFlagControlliSemplificatiManualeFromId(
                this.state.modelloBaseId,
              ).then((flagControlli) => {
                if (result === 0) {
                  this.setState({
                    showModalSelezioneModalita: true,
                    isModello: true,
                    isControlliSelectionBlocked: flagControlli,
                    isChapterSelectionBlocked: false,
                  });
                } else {
                  this.setState({
                    //loadingModal: true,
                    isModello: true,
                    isChapterSelectionBlocked: true,
                    isControlliSelectionBlocked: flagControlli,
                    showModalSelezioneModalita: true,
                  });
                }
              });
            })
            .catch((error) => {
              this.setState({
                loading: false,
              });
              reportApiError(error);
            });
        },
      );
    }
  };

  onCreaManualeDaClicked = (record, event) => {
    const isGestioneSeparata = record.tipologiaRevisione === 'DESCRITTIVA';

    if (this.props.gruppoId === null) {
      this.setState({
        loading: true,
        modelloBaseId: record.id,
        gruppoId: record.gruppoId,
        isModello: false,
        origin: 'Manuale',
        showModalSelezioneConsulente: true,
        modelloSelezionato: record,
        filtroGestioneSeparata: isGestioneSeparata,
      });
    } else if (this.props.superconsulenteView) {
      this.setState({
        loading: true,
        modelloBaseId: record.id,
        isModello: false,
        //showModalSelezioneGruppo:true,
        origin: 'Manuale',
        showModalSelezioneConsulente: true,
        modelloSelezionato: record,
        filtroGestioneSeparata: isGestioneSeparata,
      });
    } else {
      // If user is not admin nor superconsulente:
      let consulenteId = this.props.consulenteId;
      this.setState({
        loading: true,
        consulenteId,
        modelloBaseId: record.id,
        showModalSelezioneEsercizio: true,
        modelloSelezionato: record,
        filtroGestioneSeparata: isGestioneSeparata,
      });
    }
  };

  handleCloseConsulentiModal = () => {
    this.setState({
      loading: false,
      showModalSelezioneConsulente: false,
      modelloSelezionato: null,
      filtroGestioneSeparata: null,
    });
  };

  handleOpenEserciziModal = (consulenteId) => {
    this.setState({
      consulenteId,
      showModalSelezioneConsulente: false,
      showModalSelezioneEsercizio: true,
    });
  };

  handleCloseEserciziModal = () => {
    this.setState({
      loading: false,
      showModalSelezioneEsercizio: false,
      modelloSelezionato: null,
      filtroGestioneSeparata: null,
    });
  };

  onOpenModalModalita = (
    consulenteId,
    esercizioId,
    filtroGestioneSeparata = false,
  ) => {
    if (this.state.modelloBaseId === null) {
      this.setState({
        consulenteId,
        esercizioId,
        showModalSelezioneEsercizio: false,
        showModalSelezioneModalita: true,
        isChapterSelectionBlocked: false,
        isControlliSelectionBlocked: false,
        filtroGestioneSeparata,
      });
    } else {
      getCapitoliCount(this.state.modelloBaseId)
        .then((result) => {
          getFlagControlliSemplificatiManualeFromId(this.state.modelloBaseId)
            .then((flagControlli) => {
              if (result === 0) {
                this.setState({
                  consulenteId,
                  esercizioId,
                  showModalSelezioneEsercizio: false,
                  showModalSelezioneModalita: true,
                  isChapterSelectionBlocked: false,
                  isControlliSelectionBlocked: flagControlli,
                  filtroGestioneSeparata,
                });
              } else {
                this.setState({
                  consulenteId,
                  esercizioId,
                  showModalSelezioneEsercizio: false,
                  showModalSelezioneModalita: true,
                  isChapterSelectionBlocked: true,
                  isControlliSelectionBlocked: flagControlli,
                  filtroGestioneSeparata,
                });
              }
            })
            .catch((error) => {
              this.setState({
                loading: false,
              });
              reportApiError(error);
            });
        })
        .catch((error) => {
          this.setState({
            loading: false,
          });
          reportApiError(error);
        });
    }
  };

  onCloseModalModalita = () => {
    //Insert here the code to close the modal for admin
    let isAdmin =
      !this.props.superconsulenteView && this.props.consulenteId === null;
    if (isAdmin) {
      this.setState({
        showModalSelezioneModalita: false,
        loading: false,
        gruppoId: -1,
        modelloSelezionato: null,
        filtroGestioneSeparata: null,
      });
    } else {
      this.setState({
        showModalSelezioneModalita: false,
        loading: false,
        modelloSelezionato: null,
        filtroGestioneSeparata: null,
      });
    }
  };

  onCancellaOrRipristinaButtonClicked = (modello, e) => {
    this.setState({
      loading: false,
    });
    let hidden = this.state.showHiddenModels ? false : true;
    cancellaModello(modello.id, hidden)
      .then((result) => {
        this.fetchModelli(this.state.gruppoId, this.state.showHiddenModels);
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        reportApiError(error);
      });
  };

  getColumns = () => {
    const isAdmin = this.props.consulenteId === null;
    const isSuperConsulente =
      this.props.consulenteId !== null && this.props.superconsulenteView;

    return [
      {
        Header: 'Numero',
        id: 'numero',
        accessor: (row) => row,
        width: 120,
        filterable: false,
        Cell: (props) =>
          this.state.loadedPage === 0
            ? '' + props.index
            : this.state.loadedPage + '' + props.index,
      },
      this.generateFilterColumn({
        id: 'id',
        placeholder: 'ID modello',
        filterValue: this.state.filters.idModello,
        onChange: (value) => {
          if (/^\d*$/.test(value)) {
            this.setState((prevState) => ({
              filters: {
                ...prevState.filters,
                idModello: value,
              },
            }));
          }
        },
      }),
      {
        Header: 'ID modello base',
        id: 'manualeBaseId',
        accessor: (d) => d.manualeBaseId,
        width: 154,
        filterable: false,
        Cell: (props) => (props.value === null ? ' - ' : props.value),
      },
      {
        id: 'gruppoId',
        Header: 'ID gruppo',
        accessor: (row) => row.gruppoId,
        show: isAdmin,
        filterable: false,
      },
      {
        Header: 'Brand',
        id: 'brand',
        accessor: (d) => d.brandId,
        width: 120,
        filterable: false,
        Cell: (props) => {
          const brandObj = this.state.brands.find((b) => b.id === props.value);
          return brandObj ? brandObj.nome : '';
        },
      },
      this.generateFilterColumnWithEditableFields({
        id: 'titolo',
        placeholder: 'Titolo',
        filterValue: this.state.filters.titolo,
        onChange: (value) => {
          this.setState((prevState) => ({
            filters: {
              ...prevState.filters,
              titolo: value,
            },
          }));
        },
      }),
      {
        Header: 'Data aggiornamento',
        id: 'dataUltimoAggiornamento',
        filterable: false,
        accessor: (d) => moment(d.dataUltimoAggiornamento).format(dateFormat),
        width: 160,
      },
      this.generateFilterColumnWithEditableFields({
        id: 'regolamenti',
        placeholder: 'Regolamenti',
        filterValue: this.state.filters.regolamenti,
        onChange: (value) => {
          this.setState((prevState) => ({
            filters: {
              ...prevState.filters,
              regolamenti: value,
            },
          }));
        },
      }),
      {
        Header: 'Gestione separata',
        id: 'tipologiaRevisione',
        filterable: false,
        accessor: (d) => d,
        minWidth: 150,
        Cell: (props) =>
          props.value.tipologiaRevisione === 'DESCRITTIVA' ? (
            <Check style={{ color: '#7d7d7d' }} />
          ) : (
            <Remove fontSize="small" style={{ color: '#bfbfbf' }} />
          ),
      },
      {
        Header: 'Stato pubblicazione',
        id: 'stato',
        accessor: (d) => d.stato,
        minWidth: 180,
        filterable: false,
        Cell: this.renderEditableStato,
      },
      {
        id: 'modifica',
        Header: 'Modifica',
        sortable: false,
        show: !this.state.showHiddenModels && (isAdmin || isSuperConsulente),
        width: 80,
        filterable: false,
        accessor: (row) => row,
        Cell: (props) => (
          <IconButton
            style={{
              color:
                props.value.stato === 'PUBBLICATO'
                  ? this.props.theme.palette.disabled.main
                  : this.props.theme.palette.primary.main,
            }}
            size="small"
            onClick={(e) => {
              this.onModificaClicked(props.value, e);
            }}
            disabled={props.value.stato === 'PUBBLICATO'}
          >
            {this.state.edit ? <Save /> : <Settings />}
          </IconButton>
        ),
      },
      {
        id: 'modificaContenuto',
        Header: 'Modifica Contenuto',
        show: !this.state.showHiddenModels && (isAdmin || isSuperConsulente),
        width: 180,
        filterable: false,
        accessor: (row) => row,
        Cell: (props) => (
          <ModificaModelloManualeButton
            disabled={props.value.stato === 'PUBBLICATO'}
            modelloId={props.value.id}
          />
        ),
      },
      {
        id: 'clona',
        Header: 'Clona',
        show: !this.state.showHiddenModels && (isAdmin || isSuperConsulente),
        width: 80,
        filterable: false,
        accessor: (row) => row,
        Cell: (props) => (
          <IconButton
            size="small"
            disabled={props.value.stato === 'BOZZA'}
            style={{
              color:
                props.value.stato === 'BOZZA'
                  ? this.props.theme.palette.disabled.main
                  : this.props.theme.palette.primary.main,
            }}
            onClick={(e) => {
              this.onClonaClicked(props.value, e);
            }}
          >
            <FileCopyIcon />
          </IconButton>
        ),
      },
      {
        id: 'creamanuale',
        Header: 'Crea manuale da',
        show: !this.state.showHiddenModels,
        width: 152,
        filterable: false,
        accessor: (row) => row,
        Cell: (props) => (
          <IconButton
            size="small"
            disabled={props.value.stato === 'BOZZA'}
            style={{
              color:
                props.value.stato === 'BOZZA'
                  ? this.props.theme.palette.disabled.main
                  : this.props.theme.palette.primary.main,
            }}
            onClick={(e) => {
              this.onCreaManualeDaClicked(props.value, e);
            }}
          >
            <PostAddIcon />
          </IconButton>
        ),
      },
      {
        id: 'cancella',
        Header: this.state.showHiddenModels ? 'Ripristina' : 'Elimina',
        width: 80,
        filterable: false,
        show: isAdmin || isSuperConsulente,
        accessor: (row) => row,
        Cell: (props) => (
          <IconButton
            style={{ color: this.props.theme.palette.primary.main }}
            size="small"
            onClick={(e) => {
              this.onCancellaOrRipristinaButtonClicked(props.value, e);
            }}
          >
            {this.state.showHiddenModels ? <Restore /> : <HighlightOff />}
          </IconButton>
        ),
      },
    ];
  };

  onlySpaces(str) {
    if (str !== null) {
      return str.trim().length === 0;
    }
    return 'placeholder';
  }

  renderEditable = (cellInfo) => {
    return (
      <TextField
        style={
          !(
            this.state.edit === true &&
            this.state.modelloSelezionato.id === cellInfo.row.id
          )
            ? { width: '100%' }
            : {
                width: '100%',
                backgroundColor: '#FAFAFA',
              }
        }
        contentEditable
        suppressContentEditableWarning
        InputProps={{ disableUnderline: true }}
        inputProps={{
          style: { textAlign: 'center', width: '100%', color: 'black' },
        }}
        value={
          this.state.modelli[cellInfo.index] !== undefined
            ? this.state.modelli[cellInfo.index][cellInfo.column.id]
            : null
        }
        variant="standard"
        size="small"
        disabled={
          !(
            this.state.edit === true &&
            this.state.modelloSelezionato.id === cellInfo.row.id
          )
        }
        onInput={(e) => {
          const modelli = [...this.state.modelli];
          modelli[cellInfo.index][cellInfo.column.id] = e.target.value;
          this.setState({ modelli });
        }}
      >
        {this.onlySpaces(cellInfo.value) ? 'placeholder' : cellInfo.value}
      </TextField>
    );
  };

  renderEditableStato = (cellInfo) => {
    if (
      this.state.edit === true &&
      this.state.modelloSelezionato.id === cellInfo.row.id
    ) {
      return (
        <FormControl>
          <Select value={cellInfo.value} name="activated">
            <MenuItem
              value={'PUBBLICATO'}
              onClick={this.onPublicationButtonClicked}
            >
              PUBBLICATO
            </MenuItem>
            <MenuItem value={'BOZZA'}>BOZZA</MenuItem>
          </Select>
        </FormControl>
      );
    } else {
      return <div>{cellInfo.value}</div>;
    }
  };

  render() {
    const isAdmin = this.props.consulenteId === null;
    const isSuperconsulente =
      this.props.consulenteId !== null && this.props.superconsulenteView;

    return (
      <div style={{ paddingTop: '10px', minHeight: '400px' }}>
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : (
          <div style={styles.mainContainer}>
            <TablePageToolbar
              filters={
                isAdmin ? (
                  <SelezioneGruppo
                    layout="toolbar"
                    gruppoId={this.state.filters.idGruppo}
                    gruppi={this.state.gruppi}
                    disabled={false}
                    description=""
                    onGruppoSelected={this.handleSelectedGruppo}
                  />
                ) : null
              }
              secondary={
                isAdmin || isSuperconsulente ? (
                  <FormControl variant="outlined" size="small">
                    <InputLabel id="modelli-elenco-visibilita-label">
                      Elenco
                    </InputLabel>
                    <Select
                      labelId="modelli-elenco-visibilita-label"
                      label="Elenco"
                      value={this.state.showHiddenModels}
                      name="activated"
                      onChange={(e) => {
                        this.onHiddenManualiSelection(e);
                      }}
                    >
                      <MenuItem value={false}>Modelli non cancellati</MenuItem>
                      <MenuItem value={true}>Modelli cancellati</MenuItem>
                    </Select>
                  </FormControl>
                ) : null
              }
              actions={
                <ActionButton
                  label="Crea modello personalizzato"
                  disabled={!isSuperconsulente && !isAdmin}
                  onClick={this.onCreaModelloButtonClicked}
                  grayVersion={false}
                  disableMargin
                />
              }
            />
            <BasicTable
              filterable={false}
              resizable={true}
              sortable={false}
              defaultPageSize={this.state.pageSize}
              page={this.state.loadedPage}
              pages={this.state.totalPages}
              onPageChange={this.onPageChange}
              data={this.state.modelli}
              columns={this.getColumns()}
            />
          </div>
        )}
        <TwoActionsAlertDialog
          visible={this.state.twoActionsAlertVisible}
          title={this.state.modalTitle}
          message={this.state.modalMessage}
          onIndietroClicked={this.onPublicationCancelled}
          onOkClicked={this.onAlertOkButtonPressed}
        />
        {this.state.showModalSelezioneGruppo && (
          <ModalSelezioneGruppo
            gruppoId={this.state.selectedGruppoId}
            gruppi={this.state.gruppi}
            open={this.state.showModalSelezioneGruppo}
            onCancel={this.onCancelGruppoSelection}
            onGruppoSelected={this.saveSelectedGruppoForModello}
            onCreaButtonClicked={this.onCreaButtonInModalClicked}
            origin={this.state.origin}
          />
        )}
        {this.state.showModalSelezioneConsulente && (
          <ModalSelezioneConsulente
            isModalOpen={this.state.showModalSelezioneConsulente}
            openEserciziModal={this.handleOpenEserciziModal}
            gruppoId={this.state.gruppoId}
            closeModal={this.handleCloseConsulentiModal}
          />
        )}
        {this.state.showModalSelezioneEsercizio && (
          <ModalSelezioneEsercizioCommerciale
            consulenteId={this.state.consulenteId}
            gruppoId={this.state.gruppoId}
            manualeBaseId={this.state.modelloBaseId}
            tipologiaRevisione={
              this.state.modelloSelezionato?.tipologiaRevisione
            }
            filtroGestioneSeparata={this.state.filtroGestioneSeparata}
            isModalOpen={this.state.showModalSelezioneEsercizio}
            closeModal={this.handleCloseEserciziModal}
            openModalitaModal={this.onOpenModalModalita}
          />
        )}
        {this.state.showModalSelezioneModalita && (
          <ModalSelezioneModalitaModello
            idConsulente={this.state.consulenteId}
            selectedEsercizio={this.state.esercizioId}
            gruppoId={this.state.selectedGruppoId}
            filtroGestioneSeparata={this.state.filtroGestioneSeparata}
            isModello={this.state.isModello}
            manualeBaseId={this.state.modelloBaseId}
            open={this.state.showModalSelezioneModalita}
            isChapterSelectionBlocked={this.state.isChapterSelectionBlocked}
            isControlliSelectionBlocked={this.state.isControlliSelectionBlocked}
            onClose={this.onCloseModalModalita}
            onProseguiClicked={this.executeCreationModelloPersonalizzato}
            tipologiaRevisioneModello={
              this.state.modelloSelezionato?.tipologiaRevisione
            }
          />
        )}
        {this.state.showGoToPageModal && (
          <GoToPageModal
            open={this.state.showGoToPageModal}
            onCancel={this.onGoToPageCanceled}
            message={this.state.goToPageMessage}
            path={this.state.goToPagePath}
          />
        )}
        {this.state.loadingModal && (
          <LoadingModal
            open={this.state.loadingModal}
            testo={
              this.state.isModello
                ? 'Generazione modello in corso...'
                : 'Generazione manuale in corso...'
            }
          />
        )}
      </div>
    );
  }
}

ModelliPersonalizzatiTable.propTypes = {
  consulenteId: PropTypes.number,
  gruppoId: PropTypes.number,
  superconsulenteView: PropTypes.bool.isRequired,
};

export default withRouter(ModelliPersonalizzatiTable);
